import Box from '@mui/material/Box';

import { BorderedBox } from '#client/pages/EducationStudio/components/BorderedBox';
import superstyled from '#client/pages/EducationStudio/utils/superstyled';

export const HeaderTitle = superstyled({
  tag: Box,
  styles: ({ theme }) => ({
    width: '100%',
    padding: '2.5rem 1.5rem',
    borderRadius: '1rem',
    backgroundColor: '#000000',
    color: '#FFFFFF',
    [theme.breakpoints.down('sm')]: {
      padding: '1.5rem 1rem'
    }
  })
});
export const HeaderWithBottomGap = superstyled({
  tag: BorderedBox,
  styles: ({ theme }) => ({
    backgroundColor: '#FFFFFF',
    width: '100%',
    padding: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      padding: '1rem'
    }
  })
});
